import { updateSettingsFromStorage } from "./settingsActions";

export const search = (store, text) => {
    const { data } = store.getState();

    let filtered = data.map((x) => {
        var item = { ...x };
        item.isVisible =
            !text ||
            text.length < 3 ||
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
        return item;
    });

    store.setState({ data: filtered });
};

export const close = (store) => {
    const { config } = store.getState();
    store.setState({ config: { ...config, show: false } });
};

export const openCloseListener = (store) => {
    const { config } = store.getState();
    if (config.openCloseEventName) {
        document.addEventListener(
            config.openCloseEventName,
            function (e) {
                updateSettingsFromStorage(store);
                const { config } = store.getState();
                let isOpen = config.show;
                store.setState({ config: { ...config, show: !isOpen } });
            },
            false
        );
    }
};
